// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".upload__message[data-v-42f8d8d4]{margin-top:10px}.upload__description[data-v-42f8d8d4]{margin-bottom:10px}.upload__content[data-v-42f8d8d4]{align-items:center;display:flex;justify-content:center}.upload__icon[data-v-42f8d8d4]{color:var(--c-black);font-size:20px;margin-right:5px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
